import { Component, OnInit, Input, inject, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ContactVerificationEmailsMultipleComponent } from '../contact-verification-emails-multiple/contact-verification-emails-multiple.component';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';
import { ContactMappingService } from 'src/app/modules/user-profile/services/contact-mapping-service';
import { TokenResponse } from 'src/app/modules/user-profile/models/contact-token.model';
import { FormGroup, FormControl, Validators, UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrgEmailList, EmailList, OrgCollection } from 'src/app/modules/user-profile/models/contact-oeds-person.model';
import { environment } from 'src/environments/environment';
import { CompareValidatorDirective } from '../directives/compare-validator-directive';



@Component({
    selector: 'app-contact-verification-email-office',
    templateUrl: './contact-verification-email-office.component.html',
    styleUrls: ['./contact-verification-email-office.component.css'],
    imports: [FormsModule, ReactiveFormsModule, CompareValidatorDirective, ContactVerificationEmailsMultipleComponent]
})
export class ContactVerificationEmailOfficeComponent implements OnInit {
  private router = inject(Router);
  cService = inject(ContactVerificationService);
  cMapService = inject(ContactMappingService);


  readonly child = viewChild(ContactVerificationEmailsMultipleComponent);

  isbtnclicked = false;
  isNewEmailExist = false;
  emailForm: FormGroup;

  showMutiplePanel = false;
  showOfficeOhId = true;
  showOfficeOtherId = false;
  showOfficeDontUse = false;
  showOfficeAddNew = false;
  reEnterExEmail = "";
  officeEmail = "";
  newEmail = "";
  reenterNewEmail = "";
  isprivateflag: boolean;
  ppFlag = "";
  reenterOfficeEmail = "";
  isUnmappedEmailsDeleted = false;
  unMappedEmailCollection: any;
  mappedCollection: any;
  routeFlag = false;
  tokenItem: TokenResponse;
  emailList: EmailList[];
  officeEmailList: EmailList;
  orgEmailList: OrgEmailList[];
  singleOrgCollection: OrgCollection[];

  emailType = "Office";
  oedsEmailTypeKey = this.cMapService.getOedsEmailTypeKey(this.emailType);
  _this = this;

  ngOnInit(): void {
    this.emailForm = new UntypedFormGroup({
      newEmail: new UntypedFormControl('', [Validators.required]),
      newEmail2: new UntypedFormControl('', [Validators.required]),
      type: new UntypedFormControl('', [Validators.required])
    });
    this.tokenItem = this.cService.tokenDtls;
    this.emailList = this.cService.filterActiveEmailByType(this.oedsEmailTypeKey, this.cService.oedsPersonCopy.emailList);
    ////Org List
    this.orgEmailList = this.cService.oedsPersonCopy.orgEmailList;
    if (this.cService.isOfficeEmailRequired === true && this.cService.isUserTiedToMutipleOrgs === true)
      this.showMutiplePanel = true;
    else
      this.showMutiplePanel = false;
    //If user tied to mutiple orgs directly we are rendering mutiple org screen.
    if (this.showMutiplePanel == false) {
      //this.addOhidToEmailList();
      this.setOfficeEmail();
      this.setSelectedOption();
    }
    else {
      this.addOhidToEmailList();
    }
  }
  addOhidToEmailList() {
    if (this.emailList && this.cService.homeEmailOption !== 'home-1') {
      var exEmailObj = this.emailList.find(x => x.email === this.tokenItem.ohidEmail && x.oedsEmailType === this.oedsEmailTypeKey);
      if (!exEmailObj) {
        let activeEmailList = this.cService.filterActiveEmailByType(this.oedsEmailTypeKey, this.cService.oedsPersonCopy.emailList);
        let primaryFlag = this.cService.isUserTiedToMutipleOrgs ? false : true;
        //if no office email present default newly added email should be primary
        if (activeEmailList.length === 0) {
          primaryFlag = true;
        }
        this.cService.insertUpdateEmail(this.tokenItem.ohidEmail, this.oedsEmailTypeKey, primaryFlag, true);
      }
      this.emailList = this.cService.filterActiveEmailByType(this.oedsEmailTypeKey, this.cService.oedsPersonCopy.emailList);
    }
  }
  setOfficeEmail() {
    if (this.emailList.length !== 0)
      if (this.cService.existingOfficeEmail === "") {
        let exOfficeEmail = this.emailList.find(x => x.oedsEmailKey !== 0 && x.email !== this.tokenItem.ohidEmail);
        this.cService.existingOfficeEmail = exOfficeEmail === undefined ? "" : exOfficeEmail.email;
      }
    this.officeEmail = this.cService.existingOfficeEmail;
  }
  setSelectedOption() {
    switch (this.cService.officeEmailOption) {
      case 'office-1': {
        if (this.cService.homeEmailOption === 'home-1') {
          if (this.officeEmail && this.tokenItem.ohidEmail !== this.officeEmail) {
            this.toggleshowOfficeOtherId();
          }
          else {
            this.toggleshowOfficeAddNew();
          }
        }
        else {
          this.toggleshowOfficeOhId();
        }
        break;
      }
      case 'office-2': {
        this.toggleshowOfficeOtherId();
        this.reEnterExEmail = this.cService.reEnterExOfficeEmail;
        break;
      }
      case 'office-3': {
        this.toggleshowOfficeDontUse();
        break;
      }
      case 'office-4': {
        let newEmailObj = this.emailList.find(x => x.email !== this.tokenItem.ohidEmail);
        if (newEmailObj) {
          this.isNewEmailExist = true;
          this.newEmail = newEmailObj.email;
          this.reenterNewEmail = newEmailObj.email;
          this.isprivateflag = newEmailObj.privateFlag;
          if (newEmailObj.privateFlag) {
            this.ppFlag = "private"
          }
          else {
            this.ppFlag = "public"
          }
          this.updatePrimaryFlag(newEmailObj.oedsEmailKey);
        }
        this.toggleshowOfficeAddNew();
        break;
      }
      default: {
        this.toggleshowOfficeOhId();
        break;
      }
    }
  }
  updatePrimaryFlag(emailid) {
    this.emailList.map(item => { item.oedsEmailKey === emailid ? item.primaryFlag = true : item.primaryFlag = item.primaryFlag });
  }
  getIsFormvalid() {
    if (this.showMutiplePanel === true) {
      let activeEmailList = this.cService.filterActiveEmailByType(this.oedsEmailTypeKey, this.cService.oedsPersonCopy.emailList)
      if (activeEmailList.length === 0)
        return true;
      else
        return false;
    }
    else {
      if (this.cService.officeEmailOption === 'office-1' ||
        this.cService.officeEmailOption === 'office-2' && this.officeEmail === this.reEnterExEmail ||
        this.cService.officeEmailOption === 'office-3' && this.cService.isOfficeEmailRequired === false ||
        this.cService.officeEmailOption === 'office-4' && this.emailForm.valid && this.isbtnclicked ||
        this.cService.officeEmailOption === 'office-4' && this.emailForm.valid && this.isNewEmailExist) {
        return false;
      }
      else {
        return true;
      }
    }
  }

  toggleshowOfficeOhId() {
    this.cService.officeEmailOption = 'office-1';
    this.showOfficeOhId = true;
    this.showOfficeOtherId = false;
    this.showOfficeDontUse = false;
    this.showOfficeAddNew = false;
    this.resetPrimaryFlagOfExisting();
    this.cService.insertUpdateEmail(this.tokenItem.ohidEmail, this.oedsEmailTypeKey, this.cService.isUserTiedToMutipleOrgs ? false : true, true);
    this.emailList = this.cService.filterActiveEmailByType(this.oedsEmailTypeKey, this.cService.oedsPersonCopy.emailList);    
    //this.officeEmail = this.tokenItem.ohidEmail;
  }

  toggleshowOfficeOtherId() {
    this.cService.isOhidEmailChanged = true;
    this.cService.officeEmailOption = 'office-2';
    this.showOfficeOtherId = true;
    this.showOfficeOhId = false;
    this.showOfficeDontUse = false;
    this.showOfficeAddNew = false;
    this.resetPrimaryFlagOfExisting();
    this.cService.insertUpdateEmail(this.officeEmail, this.oedsEmailTypeKey, this.cService.isUserTiedToMutipleOrgs ? false : true, true);
    this.emailList = this.cService.filterActiveEmailByType(this.oedsEmailTypeKey, this.cService.oedsPersonCopy.emailList);    
  }

  toggleshowOfficeDontUse() {
    //this.cService.ohidEmailChanged = true;
    this.cService.officeEmailOption = 'office-3';
    this.showOfficeDontUse = true;
    this.showOfficeOhId = false;
    this.showOfficeOtherId = false;
    this.showOfficeAddNew = false;
    this.resetPrimaryFlagOfExisting();
    this.cService.deleteEmailByType(this.oedsEmailTypeKey);
  }

  toggleshowOfficeAddNew() {
    this.cService.isOhidEmailChanged = true;
    this.cService.officeEmailOption = 'office-4';
    this.showOfficeAddNew = true;
    this.showOfficeDontUse = false;
    this.showOfficeOhId = false;
    this.showOfficeOtherId = false;
    this.isbtnclicked = false;
    this.resetPrimaryFlagOfExisting()
  }
  resetPrimaryFlagOfExisting() {
    this.emailList.map(item => { item.oedsEmailKey === 0 ? item.primaryFlag = false : item.primaryFlag = item.primaryFlag });
  }
  checkIsEmailsNotMapped() {
    this.unMappedEmailCollection = this.child().emailList.filter((item) => (item.isMapped !== true && item.primaryFlag !== true));
    if (this.unMappedEmailCollection.length > 0) {
      this.isUnmappedEmailsDeleted = false;
      this.openConfirmModal();
    }
    else {
      this.isUnmappedEmailsDeleted = true;
    }
  }
  confirmunusedemailcheck() {
    var modal = document.getElementById('modal-1');
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("class", "modal-wrapper");

    this.child().emailList.map(x => (x.isMapped !== true && x.primaryFlag !== true) ? x.actionType = "Deleted" : x.actionType = x.actionType);

    let emails = [...this.child().emailList];
    emails = emails.filter(x => x.isMapped === true || x.primaryFlag === true);
    this.child().emailList = emails;

    this.isUnmappedEmailsDeleted = true;
    this.updatestepcount(true);
  }
  openConfirmModal() {
    var modal = document.getElementById('modal-1');
    modal.removeAttribute("aria-hidden");
    modal.setAttribute("class", "modal-wrapper modal-open");
  }

  closeConfirmModal() {
    var modal = document.getElementById('modal-1');
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("class", "modal-wrapper")
  }
  addnewofficeemail() {
    if (!this.emailList.some(x => x.email === this.newEmail && x.oedsEmailKey === this.oedsEmailTypeKey)) {
      this.resetPrimaryFlagOfExisting();
      this.cService.insertUpdateEmail(this.newEmail, this.oedsEmailTypeKey, true, this.emailForm.value.type === "private" ? true : false);
      this.isbtnclicked = true;      
      this.showOfficeAddNew = false;
    }
    else {
      this.isbtnclicked = true;
      this.showOfficeAddNew = false;
    }
  }
  canclenewofficemeail() {
    this.newEmail = "";
    this.reenterNewEmail = "";
    this.ppFlag = "";
    this.toggleshowOfficeOhId();
  }
  deleteDuplicateEmails() {
    this.emailList.map(item => { item.oedsEmailKey !== 0 && item.oedsEmailType == this.oedsEmailTypeKey && item.actionType === "" ? item.actionType = "Deleted" : item.actionType = item.actionType });
  }
  updatestepcount(isnext) {
    this.cService.reEnterExOfficeEmail = this.reEnterExEmail;
    if (isnext) {
      this.routeFlag = true;
      if ((this.cService.isOfficeEmailRequired === true && this.cService.isUserTiedToMutipleOrgs === true)) {
        this.checkIsEmailsNotMapped();
        if (this.isUnmappedEmailsDeleted) {
          this.cService.setStep('Address');
          this.cService.stepCount++;
        }
      }     
      else {
        this.deleteDuplicateEmails()
        this.cService.setStep('Address');
        this.cService.stepCount++;
      }
      if (environment.debug) console.log(JSON.stringify(this.cService.oedsPersonCopy))
    }
    else {
      this.cService.isBackNav = true;
      this.cService.setStep('Personal Email');
      this.cService.stepCount--;
    }
  }
  checkIsOhidEmailchanged(chkvalue) {
    if (chkvalue == 1) {
      this.cService.isOhidEmailChanged = true;
    }
    else {
      this.cService.isOhidEmailChanged = false;
    }
  }
}
